import { Icon } from '@mui/material';
import { OverridableStringUnion } from '@mui/types';

import { DynamicMaterialIcon } from '@app/components/Shared/DynamicMaterialIcon';
import { CategoryIconType } from '@app/types/catalog';

export interface CategoryIconProps {
  size?: OverridableStringUnion<'small' | 'inherit' | 'medium' | 'large'>;
  type: string;
  variation: string;
}

export function CategoryIcon(props: CategoryIconProps) {
  const { size, type, variation } = props;
  return (
    <>
      {type === CategoryIconType.MATERIAL_SYMBOLS ? (
        <Icon
          baseClassName="material-symbols-outlined"
          color="primary"
          fontSize={size || 'medium'}
        >
          {variation}
        </Icon>
      ) : (
        <DynamicMaterialIcon
          variation={variation}
          color="primary"
          fontSize={size || 'medium'}
        />
      )}
    </>
  );
}
